import createIcon from '../../createIcon';

/**
 * @component @name WaterfallChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNEgyMVYyMEgxOFY0Wk0zIDEzSDZWMjBIM1YxM1pNMTQgNEgxN1Y3SDE0VjRaTTEwIDVIMTNWOUgxMFY1Wk03IDEwSDEwVjE0SDdWMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WaterfallChart = createIcon('WaterfallChart', [
  [
    'path',
    {
      d: 'M18 4H21V20H18V4ZM3 13H6V20H3V13ZM14 4H17V7H14V4ZM10 5H13V9H10V5ZM7 10H10V14H7V10Z',
      key: '28tsnc',
    },
  ],
]);

export default WaterfallChart;
